export async function customAlert(message, option) {
	return new Promise((complete, failed) => {
		let wrapper = document.createElement("div");
		wrapper.className = "alert"
		document.body.append(wrapper);


		let container = document.createElement("div");
		container.className = "alert__container";
		if (Array.isArray(option)) {
			let buttons = "";
			option.forEach((opt, i) => {
				buttons += '<span class="alert__button alert__option' + i + '">' + opt + '</span>'
			})
			buttons += '<span class="alert__button alert__no">Отмена</span>'
			container.innerHTML =
				'<i class="fas fa-exclamation-circle"></i>'
				+ '<span class="alert__text">' + message + '</span>'
				+ '<div class="alert__buttons">'
				+ '<div class="alert__options">'
				+ buttons
				+ '</div>'
				+ '</div>';
		} else {
			container.innerHTML =
				'<i class="fas fa-exclamation-circle"></i>'
				+ '<span class="alert__text">' + message + '</span>'
				+ '<div class="alert__buttons">'
				+ '<span class="alert__button alert__yes">Да</span><span class="alert__button alert__no">Нет</span>'
				+ '</div>';
		}

		wrapper.append(container)

		let yes = container.querySelector(".alert__yes");
		let no = container.querySelector(".alert__no");

		if (yes) {
			yes.addEventListener("click", () => {
				document.body.removeChild(wrapper)
				complete("yes")
			})
		}
		if (no) {
			no.addEventListener("click", () => {
				document.body.removeChild(wrapper)
				complete("")
			})
		}
		if (Array.isArray(option)) {
			option.forEach((raw, i) => {
				let opt = container.querySelector(".alert__option" + i);
				if (opt) {
					opt.addEventListener("click", () => {
						document.body.removeChild(wrapper)
						complete(raw)
					})
				}
			})
		}
	})
}